import { Box } from "@chakra-ui/react";

export function HeaderCard({ title, isGreen }) {
  return (
    <Box
      as="header"
      paddingBlock=".3rem"
      textAlign="center"
      bgColor={!isGreen ? "rgb(206, 206, 206)" : "#7FBC03"}
      color={!isGreen ? "#5c5c5c" : "#fff"}
      fontWeight="bold"
    >
      {title}
    </Box>
  );
}
